import { Injectable } from '@angular/core';
import type { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import type { Observable } from 'rxjs';


@Injectable()
export class AppURLInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const appUrlReq = req.clone({
      url: getAppAbsoluteURL(req.url, window.location.toString()).toString()
    });

    return next.handle(appUrlReq);
  }
}

export function getAppAbsoluteURL(url: string, base: string | URL = window.location.toString()) {
  return new URL(url, base).toString();
}
